import { EditorController } from '@ibiz-template/runtime';
import { IBarCode2DReader } from '@ibiz/model-core';

/**
 * 二维码阅读器编辑器控制器
 *
 * @author ljx
 * @date 2024-12-10 10:09:03
 * @export
 * @class QrcodeEditorController
 * @extends {EditorController}
 */
export class QrcodeEditorController extends EditorController<IBarCode2DReader> {}
